import listmodule from './list.js';
import { CLIENTLIST_TWOFACTOR } from '../actions/clientlistactions';
const state = {
    ...listmodule.state,
    twofactor: null
};

const getters = {
    ...listmodule.getters,
    twofactor: state => state.twofactor,
};

const actions = {
    ...listmodule.actions,
    [CLIENTLIST_TWOFACTOR]: ({ commit }, twofactor) => {
        console.log('twofactor' + twofactor)
        commit(CLIENTLIST_TWOFACTOR, twofactor);
    },
};

const mutations = {
    ...listmodule.mutations,
    [CLIENTLIST_TWOFACTOR]: (state, twofactor) => {
        state.twofactor = twofactor;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};